import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { CaseBlock } from './home/cases/CaseBlock';
import { useGetCases } from './home/hooks';
import { useConfig } from './hooks';

export const RecommendedCases = () => {
  const { t } = useTranslation();
  const { data } = useGetCases(
    {
      where: {
        category: 2,
      },
    },
    {
      ssr: false,
    },
  );
  const getCases = data?.getCases;
  const getConfig = useConfig();

  if (!getCases) {
    return null;
  }

  return (
    <section className="cases cases-all cases-battle-pass case-recomented ">
      <div className="row">
        <article className="case-row" data-rar="d32ce6">
          <div className="case-row-title">
            <div className="case-row-title-name">
              <span className="mask"></span>
              <span className="name">{t('Recommended cases')}</span>
            </div>
          </div>
          <div className="case-item-wrap">
            {_.map(getCases, getCase => (
              <CaseBlock
                getCase={getCase}
                key={getCase?.id}
                isBattlePassCoins={!!getConfig?.getBattlePass}
              />
            ))}
          </div>
        </article>
      </div>
    </section>
  );
};
